export interface DataLabels {
  [key: string]: string;
}

export const DATA_LABELS: DataLabels = {
  noDataLabel: 'No matching results found',
  netOfFees: 'net of fees',
  grossOfFees: 'gross of fees',
  net: 'net',
  gross: 'gross'
};
